export const DELETION_EN = {
  title: "Account & Data Deletion",
  version: "2.0",
  updated: "2026-06-12",
  intro:
    "This page explains how to delete your HELCOO account and data, either inside the app or by direct request, what is erased immediately and what must be retained by law. It is publicly accessible without signing in, to satisfy Google Play's account-deletion URL requirement and Apple's in-app deletion requirement.",
  sections: [
    {
      h: "1. Deleting inside the app (the direct route)",
      p: [
        "Open the app → sign in → \"Settings\" → \"Delete account and data\" → confirm.",
        "Deletion is executed immediately, with no human review and no waiting period: your face template and reference images are erased, every session on every device is revoked, and the account is permanently disabled and can no longer sign in.",
        "The action is irreversible. An account cannot be restored after deletion is confirmed.",
      ],
    },
    {
      h: "2. Deleting by direct request (without the app)",
      p: [
        "Email us from your registered address to support@helcoo.uk with the subject \"Account deletion\", stating your company name.",
        "We verify your identity and complete the deletion within a maximum of 30 days (typically within two business days) and send you written confirmation.",
      ],
    },
    {
      h: "3. What is erased immediately",
      p: [
        "Face template and all reference images · profile photo · device push tokens · all login sessions and recovery codes · personal contact details (phone, address, emergency contact).",
      ],
    },
    {
      h: "4. What may be retained and why",
      p: [
        "Attendance, payroll, leave, disciplinary and financial records remain in the employer's account because they are employment and accounting records that the law requires to be kept (typically 5–10 years depending on the company's country) and are owned by the employer as data controller.",
        "Those records are stripped of your erasable personal identifiers (replaced by the record's reference number) and are not used to re-identify you.",
        "Security and audit logs are kept for a limited period for fraud prevention and legal compliance, then deleted automatically.",
      ],
    },
    {
      h: "5. Deleting an entire company account",
      p: [
        "If you are a company administrator and wish to delete the company account and all employee data, email support@helcoo.uk from the registered administrator address.",
        "The company is given 30 days to export its data, after which all data is permanently deleted from databases and from backups according to the backup rotation cycle (up to a further 35 days for backups).",
      ],
    },
    {
      h: "6. Cancelling a subscription is not deletion",
      p: [
        "Cancelling a subscription stops billing and access but does not delete data automatically. To have data deleted you must submit a deletion request explicitly as described above.",
      ],
    },
  ],
};
